<template>
  <div id="text-field-component">
    <div class="form-group">
      <label v-if="label !== ''" :for="name">
        {{ label }}
        <span v-if="mandatory" class="text-danger"> * </span>
        <font-awesome-icon
          v-if="tooltipMessage"
          class="ml-2"
          icon="fa-exclamation-circle fa-sm"
          v-b-tooltip.top="tooltipMessage"
        />
        <!-- <b-icon
          v-if="tooltipMessage"
          class="ml-2"
          icon="exclamation-circle-fill"
          v-b-tooltip.top="tooltipMessage"
        ></b-icon> -->
      </label>
      <input
        :id="`${name}-${index || ''}`"
        type="text"
        class="form-control"
        :class="`form-control-${size} ${
          fieldState === false ? 'is-invalid' : ''
        }`"
        autocomplete="off"
        :value="modelValue"
        :placeholder="placeholder"
        :name="name"
        :readonly="isDisable"
        :state="fieldState"
        @blur="$emit('blurEvent', name, index)"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <small class="text-muted"> {{ additionalMessage }} </small>
      <error-message-new
        v-if="!fieldState"
        :index="index"
        :errors="errors"
        :fieldName="name"
        :parent="parent"
        :ui-error-message="uiErrorMessage"
      />
    </div>
  </div>
</template>

<script>
import { $hasField } from "@/helper/globalFunction.js";
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    tooltipMessage: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: "sm",
    },
    isDisable: {
      type: Boolean,
      default: null,
    },
    parent: {
      type: String,
      default: null,
    },
    additionalMessage: {
      type: String,
      default: "",
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: [Array, Object],
      default: null,
    },
    logic: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: Object,
      default: () => ({}),
    },
    uiErrorMessage: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    localValue: null,
  }),
  computed: {
    fieldState() {
      return (
        this.$hasField({
          name: this.name,
          errors: this.errors,
          index: this.index,
          parent: this.parent,
        }) && this.showError
      );
    },
    rules() {
      if (this.type === "email") {
        return "emailFormat";
      }

      return "";
    },
  },
  methods: { $hasField, handleFieldState },
};
</script>
